import { Outlet, useNavigation } from "react-router-dom";
import { useFocusMain } from "@/lib/a11y/useFocusMain";
import { FullPageLoading } from "@/components/layout/FullPageLoading";

/**
 * Wurzel-Layout für alle Routen: Skip-Link + aria-live-Announcer aus index.html
 * (bisher statisches Markup, jetzt Teil des React-Baums) plus Fokus-Steuerung
 * bei Routenwechseln.
 */
export function AppShell() {
  useFocusMain();
  const navigation = useNavigation();

  return (
    <div className="app-container">
      <a className="skip-link" href="#main-content">
        Zum Hauptinhalt springen
      </a>
      <div id="app-announcer" className="sr-only" aria-live="assertive" aria-atomic="true" />
      {/* navigation.state ist während des Nachladens einer lazy-Route (admin/onboarding
          Chunk) "loading" — ansonsten "idle", clientseitige Interaktionen lösen das nicht aus. */}
      {navigation.state === "loading" ? <FullPageLoading /> : <Outlet />}
    </div>
  );
}
